import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ru from 'vuetify/es5/locale/ru';
import de from 'vuetify/es5/locale/de';
import en from 'vuetify/es5/locale/en';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: {
            ru, en, de
        },
        current: 'ru'
    },
    theme: {
        themes: {
            light: {
                primary: '#0B2043',
                secondary: '#4F7DB2',
                accent: '#E15D29',
                danger: '#FA86AA',
                success: '#4BA16E'
            },
        },
    },
});
